import axios from "axios";
import { useCallback } from "react";

const CLIENT_ID = process.env.REACT_APP_BIGQUERY_CLIENT_ID;
const CLIENT_SECRET = process.env.REACT_APP_BIGQUERY_CLIENT_SECRET;
const REFRESH_TOKEN = process.env.REACT_APP_BIGQUERY_REFRESH_TOKEN;
const PROJECT_ID = process.env.REACT_APP_BIGQUERY_PROJECT_ID;
const DB_ID = process.env.REACT_APP_BIGQUERY_DB_ID;

// console.log("CLIENT_ID : ", CLIENT_ID);
// console.log("CLIENT_SECRET : ", CLIENT_SECRET);
// console.log("REFRESH_TOKEN : ", REFRESH_TOKEN);
// console.log("PROJECT_ID : ", PROJECT_ID);

export const getAccessToken = async (): Promise<string> => {
  const params = new URLSearchParams();
  params.append("grant_type", "refresh_token");
  params.append("client_id", CLIENT_ID);
  params.append("client_secret", CLIENT_SECRET);
  params.append("refresh_token", REFRESH_TOKEN);

  try {
    const response = await axios.post(
      "https://oauth2.googleapis.com/token",
      params
    );
    return response.data.access_token;
  } catch (error) {
    console.error("Error fetching access token:", error);
    throw error;
  }
};

const projectId = PROJECT_ID;
export const endpoint = `https://bigquery.googleapis.com/bigquery/v2/projects/${projectId}/queries`;

export const QUERY_FINAL = `
  SELECT
  user_id,
  ep.value.string_value as song_id,
  COUNTIF(event_name = 'song_play_start') as song_play_start_cnt,
  COUNTIF(event_name = 'song_play_30sec') as song_play_30sec_cnt,
  COUNTIF(event_name = 'song_play_60sec') as song_play_60sec_cnt,
  COUNTIF(event_name = 'song_play_90sec') as song_play_90sec_cnt,
  COUNTIF(event_name = 'song_play_complete') as song_play_complete_cnt,
FROM
  \`${"homebrew-prod.analytics_444893970.events_*"}\`,
  UNNEST(event_params) as ep
WHERE
  event_name in ('song_play_start','song_play_30sec','song_play_60sec','song_play_90sec','song_play_complete')
  AND
  ep.key = 'song_id'
  AND
  ep.value.string_value is not null
GROUP BY
  user_id,
  ep.value.string_value
ORDER BY
  user_id,
  song_id
`;

export const QUERY0 = `
  SELECT
    user_id,
    up.value.int_value as ga_session_number,
    DATETIME(TIMESTAMP_MICROS(event_timestamp), 'Asia/Seoul') as event_time,
    event_name,
    ep.value.string_value as song_id
  FROM
    \`${DB_ID}\`,
    UNNEST(user_properties) as up,
    UNNEST(event_params) as ep
  WHERE
    event_name in ('song_play_start', 'song_play_30sec', 'song_play_60sec', 'song_play_90sec', 'song_play_complete')
    AND ep.key = 'song_id'
    AND up.key = 'ga_session_number'
    AND event_timestamp >= UNIX_MICROS(TIMESTAMP('2024-06-16 12:00:00 UTC'))
    AND geo.country = "South Korea"
    AND user_id is not null
    AND user_pseudo_id not in (
      "bf59cafc9a04651941aa9377657fa16b", "55b26b539b16b1de31ae2cb842cd20e2", "814bea7eb6fcaefe1c30657213967016",
      "9bcd560e196b7bf1e326dd9a6ae5e70e", "b8a936d70ed39ad2928ba07f10dab3ab", "4cd4e8258ba7e5465bab7afed84bbdc9",
      "c7be0bff51b8fc3fc27322881ac1624a", "798fb8d1435560be19bf21b37f1b7183", "d6c6f155ff1c984003a12afdf78208b8",
      "2bbe7a6f55f1a0471ff3fc8b271e67eb", "38d713dd1ea3941e72514d6e838065f6", "0ec0f43172cd92280c9077d8bb42e810",
      "334d1daad757fa702840f355752edcce", "65349c02a088b11b7af280f01cfa6af5", "a7195bf047aa2a7fa09954ef8af49694",
      "3b9fbe8dbeb993695a22a4c9ac24750b", "09009d163843cc9eda5538ce72810c94", "78ca56ccadd47309fe1729f8319783bc",
      "a7cb07154e762f90daab1a41f957c87d", "1ce7b2df65da190440f9593951b1debf", "93c649a6a596a19387c3506849d9a07a",
      "4563675f4b3332d4ff54fca171acb6c1", "c19fb0ff421840357f0e759838598292", "0632d0174d1ead20197b6c76560249f0",
      "ee9bcd20a6a0d57760886fb5b506b21f", "40041bd51f78ecd16d8888597e388194", "bcedf1782ba2a581abf4272943ea2a11",
      "14ec52445462b452e97476f5c66fdf89", "ca9f2941703988c48314cf0f8d8f5a7c", "ad6368d420df91a0b0120a4ffccee3e9"
    )
    AND user_pseudo_id not in (
      "FDF781BFBF4A409F8B59B996BEE66954", "BE802B0DED4649EEB96C9E9638B023E2", "F1E41B906FBB4AEE965EDA9C7B5B9187"
    )
  ORDER BY
    user_id,
    event_time
`;

export const QUERY1 = `
  SELECT * FROM  \`${DB_ID}\`
`;

export const QUERY_SONG_PLAY_START = `
  SELECT
    user_id,
    up.value.int_value as ga_session_number,
    DATETIME(TIMESTAMP_MICROS(event_timestamp), 'Asia/Seoul') as event_time,
    event_name,
    ep.value.string_value as song_id
  FROM
    \`${DB_ID}\`,
    UNNEST(user_properties) as up,
    UNNEST(event_params) as ep
  WHERE
    event_name in ('song_play_start')
    AND ep.key = 'song_id'
    AND up.key = 'ga_session_number'
    AND event_timestamp >= UNIX_MICROS(TIMESTAMP('2024-06-16 12:00:00 UTC'))
    AND geo.country = "South Korea"
    AND user_id is not null
    AND user_pseudo_id not in (
      "bf59cafc9a04651941aa9377657fa16b", "55b26b539b16b1de31ae2cb842cd20e2", "814bea7eb6fcaefe1c30657213967016",
      "9bcd560e196b7bf1e326dd9a6ae5e70e", "b8a936d70ed39ad2928ba07f10dab3ab", "4cd4e8258ba7e5465bab7afed84bbdc9",
      "c7be0bff51b8fc3fc27322881ac1624a", "798fb8d1435560be19bf21b37f1b7183", "d6c6f155ff1c984003a12afdf78208b8",
      "2bbe7a6f55f1a0471ff3fc8b271e67eb", "38d713dd1ea3941e72514d6e838065f6", "0ec0f43172cd92280c9077d8bb42e810",
      "334d1daad757fa702840f355752edcce", "65349c02a088b11b7af280f01cfa6af5", "a7195bf047aa2a7fa09954ef8af49694",
      "3b9fbe8dbeb993695a22a4c9ac24750b", "09009d163843cc9eda5538ce72810c94", "78ca56ccadd47309fe1729f8319783bc",
      "a7cb07154e762f90daab1a41f957c87d", "1ce7b2df65da190440f9593951b1debf", "93c649a6a596a19387c3506849d9a07a",
      "4563675f4b3332d4ff54fca171acb6c1", "c19fb0ff421840357f0e759838598292", "0632d0174d1ead20197b6c76560249f0",
      "ee9bcd20a6a0d57760886fb5b506b21f", "40041bd51f78ecd16d8888597e388194", "bcedf1782ba2a581abf4272943ea2a11",
      "14ec52445462b452e97476f5c66fdf89", "ca9f2941703988c48314cf0f8d8f5a7c", "ad6368d420df91a0b0120a4ffccee3e9"
    )
    AND user_pseudo_id not in (
      "FDF781BFBF4A409F8B59B996BEE66954", "BE802B0DED4649EEB96C9E9638B023E2", "F1E41B906FBB4AEE965EDA9C7B5B9187"
    )
  ORDER BY
    user_id,
    event_time
  LIMIT 5
`;

export const QUERY_ARTIST_USER_ID_LIST = `
WITH base AS (
  SELECT
    user_pseudo_id,
    (SELECT value.string_value FROM UNNEST(event_params) WHERE key = "song_id") AS song_id
  FROM \`homebrew-prod.analytics_444893970.events_*\`
  WHERE
    event_name = 'song_play_start'
    AND geo.country = "South Korea"
    AND user_pseudo_id IS NOT NULL
    AND user_pseudo_id NOT IN (
      "bf59cafc9a04651941aa9377657fa16b","55b26b539b16b1de31ae2cb842cd20e2","814bea7eb6fcaefe1c30657213967016",
      "9bcd560e196b7bf1e326dd9a6ae5e70e","b8a936d70ed39ad2928ba07f10dab3ab","4cd4e8258ba7e5465bab7afed84bbdc9",
      "c7be0bff51b8fc3fc27322881ac1624a","798fb8d1435560be19bf21b37f1b7183","d6c6f155ff1c984003a12afdf78208b8",
      "2bbe7a6f55f1a0471ff3fc8b271e67eb","38d713dd1ea3941e72514d6e838065f6","0ec0f43172cd92280c9077d8bb42e810",
      "334d1daad757fa702840f355752edcce","65349c02a088b11b7af280f01cfa6af5","a7195bf047aa2a7fa09954ef8af49694",
      "3b9fbe8dbeb993695a22a4c9ac24750b","09009d163843cc9eda5538ce72810c94","78ca56ccadd47309fe1729f8319783bc",
      "a7cb07154e762f90daab1a41f957c87d","1ce7b2df65da190440f9593951b1debf","93c649a6a596a19387c3506849d9a07a",
      "4563675f4b3332d4ff54fca171acb6c1","c19fb0ff421840357f0e759838598292","0632d0174d1ead20197b6c76560249f0",
      "ee9bcd20a6a0d57760886fb5b506b21f","40041bd51f78ecd16d8888597e388194","bcedf1782ba2a581abf4272943ea2a11",
      "14ec52445462b452e97476f5c66fdf89","ca9f2941703988c48314cf0f8d8f5a7c","ad6368d420df91a0b0120a4ffccee3e9"
    )
    AND user_pseudo_id NOT IN ("FDF781BFBF4A409F8B59B996BEE66954","BE802B0DED4649EEB96C9E9638B023E2","F1E41B906FBB4AEE965EDA9C7B5B9187")
),
base2 AS (
  SELECT
    base.*,
    sa.artist_id
  FROM base
  LEFT JOIN \`homebrew-prod.firestore_data.songId-artistId\` AS sa
  ON base.song_id = sa.song_id
),
base3 AS (
  SELECT
    user_pseudo_id,
    artist_id,
    COUNT(*) AS cnt
  FROM base2
  GROUP BY ALL
  HAVING artist_id IS NOT NULL
),
base4 AS (
  SELECT
    *,
    SUM(cnt) OVER(PARTITION BY user_pseudo_id) AS total_song_play_start_cnt,
    MAX(cnt) OVER(PARTITION BY user_pseudo_id) AS max_artist_song_play_start_cnt,
    FIRST_VALUE(artist_id) OVER(PARTITION BY user_pseudo_id ORDER BY cnt DESC, artist_id) AS favorite_artist
  FROM base3
  ORDER BY user_pseudo_id, cnt DESC
)
SELECT
  hpcu.user_id,
  b.favorite_artist
FROM base4 b
LEFT JOIN \`homebrew-prod.custom.userId-pseudo\` hpcu
ON b.user_pseudo_id = hpcu.user_pseudo_id
WHERE
  total_song_play_start_cnt > 10
  AND hpcu.user_id IS NOT NULL
GROUP BY ALL
`;
